import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "showBreezeIcon"];
import { BreezeSingleStarIcon } from 'foundations-assets';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { getStyledAIButton } from './styledButtons/StyledAIBaseButton';
import { BREEZE_SPECIAL } from '../../../constants/BreezeUse';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IconWrapper = styled.span.withConfig({
  displayName: "AIBaseButton__IconWrapper",
  componentId: "sc-1vlzov0-0"
})(["display:inline-block;transform:translateY(1px);line-height:1;vertical-align:top;height:1em;"]);
export function AIBaseButton(_ref) {
  let {
      children,
      showBreezeIcon = true
    } = _ref,
    uiButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const useOverride = uiButtonProps.use === BREEZE_SPECIAL ? undefined : uiButtonProps.use;
  const AIButtonComponent = getStyledAIButton(uiButtonProps.use);
  const {
    tokenProps,
    restProps
  } = filterTokenProps(uiButtonProps);
  const cssProps = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(AIButtonComponent, Object.assign({
    $cssStyles: cssProps
  }, restProps, {
    use: useOverride,
    children: [showBreezeIcon && /*#__PURE__*/_jsx(IconWrapper, {
      children: /*#__PURE__*/_jsx(BreezeSingleStarIcon, {})
    }), children]
  }));
}